import { IEnvironment } from './ienvironment';

export var environment: IEnvironment = {
  production: false,
  envName: 'staging',
  VERSION: require('../../package.json').version,
  NAME: require('../../package.json').name,
};
